export const RESERVATION_STATUS = {
  RESERVED: 'RESERVED',
  EXPIRED: 'EXPIRED',
};
